import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const module1Keys = (t) => [
    {
        key: 'position1',
        label: t('search.position_distribution.chart.rank1'),
        icon: 'clicks',
    },
    {
        key: 'positiontop3',
        label: t('search.position_distribution.chart.rank1to3'),
        icon: 'search',
    },
    {
        key: 'position4to10',
        label: t('search.position_distribution.chart.rank4to10'),
        icon: 'pagev-view',
    },
    {
        key: 'position2',
        label: t('search.position_distribution.chart.rankPage2'),
        icon: 'ctr',
        hidden: true,
    },
    {
        key: 'position3',
        label: t('search.position_distribution.chart.rankPage3'),
        icon: 'pagev-view',
        hidden: true,
    },
    {
        key: 'position4',
        label: t('search.position_distribution.chart.rankPage4'),
        icon: 'pagev-view',
        hidden: true,
    },
    {
        key: 'position5',
        label: t('search.position_distribution.chart.rankPage5'),
        icon: 'pagev-view',
        hidden: true,
    },
];

export const pieChartKeys = (t) => [
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks1' },
            { chartKey: 'position', key: 'position1' },
            { chartKey: 'impressions', key: 'impressions1' },
        ],
        label: t('search.position_distribution.chart.rank1'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clickstop3' },
            { chartKey: 'position', key: 'positiontop3' },
            { chartKey: 'impressions', key: 'impressionstop3' },
        ],
        label: t('search.position_distribution.chart.rank1to3'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks4to10' },
            { chartKey: 'position', key: 'position4to10' },
            { chartKey: 'impressions', key: 'impressions4to10' },
        ],
        label: t('search.position_distribution.chart.rank4to10'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks2' },
            { chartKey: 'position', key: 'position2' },
            { chartKey: 'impressions', key: 'impressions2' },
        ],
        label: t('search.position_distribution.chart.rankPage2'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks3' },
            { chartKey: 'position', key: 'position3' },
            { chartKey: 'impressions', key: 'impressions3' },
        ],
        label: t('search.position_distribution.chart.rankPage3'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks4' },
            { chartKey: 'position', key: 'position4' },
            { chartKey: 'impressions', key: 'impressions4' },
        ],
        label: t('search.position_distribution.chart.rankPage4'),
    },
    {
        keys: [
            { chartKey: 'clicks', key: 'clicks5' },
            { chartKey: 'position', key: 'position5' },
            { chartKey: 'impressions', key: 'impressions5' },
        ],
        label: t('search.position_distribution.chart.rankPage5'),
    },
];

export const tableColumns = (t) => [
    {
        label: t('search.position_distribution.table.ranking'),
        key: 'label',
        data: 'label',
        Component: Cell,
    },
    {
        label: t('search.position_distribution.table.numberOfKeywords'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.position_distribution.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.position_distribution.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.position_distribution.table.avgCTR'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item }) => numeral(item.clicks / item.impressions).format('0.00%'),
    },
];

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
